import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

// Este componente envuelve las rutas que requieren autenticación.
// Recibe el componente a renderizar como 'children'.
function ProtectedRoute({ children }) {
  const { currentUser } = useAuth();

  // Si no hay usuario logueado, redirige a la página de login.
  // 'replace' evita que la ruta protegida quede en el historial del navegador.
  if (!currentUser) {
    return <Navigate to="/login" replace />;
  }

  // Si hay usuario logueado, renderiza el componente hijo (la página protegida).
  return children;
}

export default ProtectedRoute; 